import { APPROVED_SALES_LISTING,LEDGER_LISTING,GET_SITE_CHALLAN } from "./type";

const initalState = {
  postSalesList: {},
  ledgerList: {},
  siteChallans: {}
};

const approvedSalesListReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case APPROVED_SALES_LISTING:
      return {
        ...state,
        postSalesList: payload,
      };
    case LEDGER_LISTING:
      return {
        ...state,
        ledgerList: payload,
      };  
    case GET_SITE_CHALLAN:
      return {
        ...state,
        siteChallans: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default approvedSalesListReducer;
